import type { Metadata } from "next";
import AdminBrandsListing from '@/Component/Admin/AdminBrandsListing'

export const metadata: Metadata = {
    title: "Brands | Connector Club",
    description: "",
};

const AdminBrandListPage = () => {
  return (
    <AdminBrandsListing />
  )
}

export default AdminBrandListPage
